var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormatIndentLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-3h24v24H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.179 15.962H18.82c.375 0 .679.304.679.68v.679c0 .375-.304.679-.679.679H1.18a.679.679 0 01-.679-.68v-.678c0-.376.304-.68.679-.68zm17.163-2.577L14.27 9.31a.68.68 0 010-.96l4.072-4.076a.68.68 0 011.158.48v8.152a.679.679 0 01-1.158.48zM1.044 5.095h9.769c.3 0 .544.243.544.543v.949c0 .301-.243.545-.543.545h-9.77A.544.544 0 01.5 6.588v-.949c0-.3.243-.544.543-.545h.001zM1.18 0H18.82c.375 0 .679.304.679.68v.678c0 .376-.304.68-.679.68H1.18a.679.679 0 01-.679-.68V.68C.5.304.804 0 1.179 0zm-.135 10.528h9.769c.3 0 .544.244.544.544v.949c0 .301-.243.545-.543.545h-9.77a.544.544 0 01-.544-.544v-.949c0-.3.243-.544.543-.545h.001z",
    fill: "#151A30"
  }))));
}

export default SvgFormatIndentLeft;